"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CELL_STRIDE = 2;
exports.CELL_SIZE = 12;
//# sourceMappingURL=config.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/face-api.js/build/commonjs/mtcnn/config.js
 ** module id = 392
 ** module chunks = 0
 **/